module.exports = __webpack_public_path__ + "img/Team_rechts.8598ecb4.jpg";